try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/HOOD_NOIR_-_146BPM_D_MIN.mp3?v=1774276539",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/DARKNESS_-_151BPM_G_MIN.mp3?v=1774276539",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/PHANTOM_-_148BPM_F_MIN.mp3?v=1774276539",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/OMINOUS_-_164_BPM_C_MIN.mp3?v=1774276539"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/HOOD_NOIR_-_146BPM_D_MIN.json?v=1774276538",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/DARKNESS_-_151BPM_G_MIN.json?v=1774276538",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/PHANTOM_-_148BPM_F_MIN.json?v=1774276538",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/OMINOUS_-_164_BPM_C_MIN.json?v=1774276538"
  ];

  const elements = document.querySelectorAll('#player-set-4 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/HOOD_NOIR_-_146BPM_D_MIN.mp3?v=1774276539",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/DARKNESS_-_151BPM_G_MIN.mp3?v=1774276539",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/PHANTOM_-_148BPM_F_MIN.mp3?v=1774276539",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/OMINOUS_-_164_BPM_C_MIN.mp3?v=1774276539"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/HOOD_NOIR_-_146BPM_D_MIN.json?v=1774276538",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/DARKNESS_-_151BPM_G_MIN.json?v=1774276538",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/PHANTOM_-_148BPM_F_MIN.json?v=1774276538",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/OMINOUS_-_164_BPM_C_MIN.json?v=1774276538"
  ];

  const elements = document.querySelectorAll('#player-set-11412 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/STREET_SERENADE_-_121BPM_G_MIN.mp3?v=1774276717",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/KINSHIP_-_149BPM_D_MIN.mp3?v=1774276718",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/THE_JOURNEY_-_124BPM_F_MIN.mp3?v=1774276717",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/PROSPERITY_-_160BPM_A_MIN.mp3?v=1774276717"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/STREET_SERENADE_-_121BPM_G_MIN.json?v=1774276716",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/KINSHIP_-_149BPM_D_MIN.json?v=1774276716",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/THE_JOURNEY_-_124BPM_F_MIN.json?v=1774276717",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/PROSPERITY_-_160BPM_A_MIN.json?v=1774276716"
  ];

  const elements = document.querySelectorAll('#player-set-6 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/MIDNIGHT_CALL_-_144BPM_E_MIN.mp3?v=1774277052",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/OPULENT_-_149BPM_D_MIN.mp3?v=1774277051",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/GRACEFUL_-_155BPM_F_MIN.mp3?v=1774277051",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/MELLOW_MOOD_-_185BPM_G_MIN.mp3?v=1774277051"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/OPULENT_-_149BPM_D_MIN.json?v=1774277049",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/OPULENT_-_149BPM_D_MIN.json?v=1774277049",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/GRACEFUL_-_155BPM_F_MIN.json?v=1774277049",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/MELLOW_MOOD_-_185BPM_G_MIN.json?v=1774277049"
  ];

  const elements = document.querySelectorAll('#player-set-8 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/LATE_NIGHTS_-_155BPM_D_MIN.mp3?v=1774276892",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/TOP_FLOOR_-_137BPM_C_MIN.mp3?v=1774276891",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/IMPACT_-_152BPM_D_MIN.mp3?v=1774276891",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/THE_SIX_-_122BPM_E_MIN.mp3?v=1774276892"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/LATE_NIGHTS_-_155BPM_D_MIN.json?v=1774276889",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/TOP_FLOOR_-_137BPM_C_MIN.json?v=1774276888",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/IMPACT_-_152BPM_D_MIN.json?v=1774276888",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/THE_SIX_-_122BPM_E_MIN.json?v=1774276888"
  ];

  const elements = document.querySelectorAll('#player-set-7 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/STREET_SERENADE_-_121BPM_G_MIN.mp3?v=1774276717",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/KINSHIP_-_149BPM_D_MIN.mp3?v=1774276718",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/THE_JOURNEY_-_124BPM_F_MIN.mp3?v=1774276717",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/PROSPERITY_-_160BPM_A_MIN.mp3?v=1774276717"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/STREET_SERENADE_-_121BPM_G_MIN.json?v=1774276716",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/KINSHIP_-_149BPM_D_MIN.json?v=1774276716",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/THE_JOURNEY_-_124BPM_F_MIN.json?v=1774276717",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/PROSPERITY_-_160BPM_A_MIN.json?v=1774276716"
  ];

  const elements = document.querySelectorAll('#player-set-114123 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/MIDNIGHT_CALL_-_144BPM_E_MIN.mp3?v=1774277052",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/OPULENT_-_149BPM_D_MIN.mp3?v=1774277051",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/GRACEFUL_-_155BPM_F_MIN.mp3?v=1774277051",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/MELLOW_MOOD_-_185BPM_G_MIN.mp3?v=1774277051"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/OPULENT_-_149BPM_D_MIN.json?v=1774277049",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/OPULENT_-_149BPM_D_MIN.json?v=1774277049",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/GRACEFUL_-_155BPM_F_MIN.json?v=1774277049",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/MELLOW_MOOD_-_185BPM_G_MIN.json?v=1774277049"
  ];

  const elements = document.querySelectorAll('#player-set-3117 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/LATE_NIGHTS_-_155BPM_D_MIN.mp3?v=1774276892",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/TOP_FLOOR_-_137BPM_C_MIN.mp3?v=1774276891",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/IMPACT_-_152BPM_D_MIN.mp3?v=1774276891",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/THE_SIX_-_122BPM_E_MIN.mp3?v=1774276892"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/LATE_NIGHTS_-_155BPM_D_MIN.json?v=1774276889",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/TOP_FLOOR_-_137BPM_C_MIN.json?v=1774276888",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/IMPACT_-_152BPM_D_MIN.json?v=1774276888",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/THE_SIX_-_122BPM_E_MIN.json?v=1774276888"
  ];

  const elements = document.querySelectorAll('#player-set-117 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
